// Native Modules
import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules} from '@angular/router';

// Components
import { LayoutComponent } from './components/layout/layout.component';

// Routes Declaration
const routes: Routes = [
  { path: '',
  component: LayoutComponent,
  children: [
      { path: '', loadChildren: () => import('./home/home.module').then(m => m.HomeModule) },
      { path: 'reservar', loadChildren: () => import('./reserve/reserve.module').then(m => m.ReserveModule) },
      { path: 'terminos-y-condiciones', loadChildren: () => import('./terms/terms.module').then(m => m.TermsModule) },
      { path: 'preguntas-frecuentes', loadChildren: () => import('./faq/faq.module').then(m => m.FaqModule) }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
